import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonToolbar,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { MEDICATION_APPLICATION_STATUS } from '../../../shared/utils/constants';

function MedicalApplicationModal(props) {
  const {
    title,
    colored,
    toggle,
    modal,
    t,
    updateApplicationObservation,
    applicationType,
  } = props;

  const [observation, setObservation] = useState('');
  const [backdrop] = useState(false);

  const updateInput = (event) => {
    setObservation(event.target.value);
  };

  const onConfirmClickHandler = () => {
    if (
      observation.trim() ||
      applicationType === MEDICATION_APPLICATION_STATUS.APPLIED
    ) {
      updateApplicationObservation(observation);
      setObservation('');
      return;
    }

    if (applicationType === MEDICATION_APPLICATION_STATUS.CANCELED) {
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.cancel-reason')
      );
    }
  };

  return (
    <div>
      <Modal
        isOpen={modal}
        backdrop={backdrop}
        toggle={toggle}
        className="modal-aplication"
      >
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Input
                type="textarea"
                className="input"
                onChange={updateInput}
                value={observation}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonToolbar>
            <Button color="primary" onClick={toggle}>
              {t('general.cancel')}
            </Button>{' '}
            <Button
              outline={colored}
              color="success"
              onClick={onConfirmClickHandler}
            >
              {t('general.confirm')}
            </Button>
          </ButtonToolbar>
        </ModalFooter>
      </Modal>
    </div>
  );
}
MedicalApplicationModal.propTypes = {
  title: PropTypes.string,
  colored: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  updateApplicationObservation: PropTypes.func.isRequired,
  applicationType: PropTypes.string,
};

MedicalApplicationModal.defaultProps = {
  title: '',
  colored: false,
  applicationType: MEDICATION_APPLICATION_STATUS.CANCEL,
};

export default withTranslation('common')(MedicalApplicationModal);
